<!--
  Модалка массовой смены транспорта у выбранных расходов
-->
<template>
  <BaseModal
    :visible="true"
    title="Изменить транспорт"
    size="md"
    footer-align="start"
    elevated-footer
    @close="$emit('close')"
  >
    <form
      id="bulk-change-vehicle-form"
      @submit.prevent="handleSubmit"
      class="modal-form"
    >
      <p class="info-text">
        Выбрано расходов:
        <strong>{{ expenses.length }}</strong>
      </p>

      <!-- Новый транспорт применяется ко всем выбранным расходам -->
      <BaseFormField
        label="Новый транспорт"
        for-id="new-vehicle"
        required
        :filled="!!newVehicleId"
        :error="hasError"
      >
        <vehicle-select
          id="new-vehicle"
          v-model="newVehicleId"
          placeholder="Выберите транспорт"
          :clearable="false"
          @update:modelValue="hasError = false"
        />
      </BaseFormField>
    </form>

    <template #footer>
      <base-primary-button
        type="submit"
        form="bulk-change-vehicle-form"
        :disabled="isSubmitting"
        class="form-btn"
      >
        <span v-if="isSubmitting">Сохранение...</span>
        <span v-else>Применить</span>
      </base-primary-button>
      <base-button
        type="button"
        @click="$emit('close')"
        class="form-btn"
        :disabled="isSubmitting"
      >
        Отмена
      </base-button>
    </template>
  </BaseModal>
</template>

<script>
import { getCompanyId } from "@/utils/userUtils";
import { useNotificationStore } from "@/stores/notificationStore";
import expensesApi from "@/services/api/expensesApi";
import VehicleSelect from "@/components/Vehicle/VehicleSelect.vue";

export default {
  name: "BulkChangeVehicleModal",
  components: {
    VehicleSelect,
  },
  props: {
    expenses: {
      type: Array,
      required: true,
    },
  },
  emits: ["close", "changed"],
  data() {
    return {
      newVehicleId: null,
      hasError: false,
      isSubmitting: false,
      companyId: getCompanyId(),
    };
  },
  methods: {
    async handleSubmit() {
      if (!this.newVehicleId) {
        this.hasError = true;
        return;
      }

      const notificationStore = useNotificationStore();

      try {
        this.isSubmitting = true;

        const responses = await Promise.all(
          this.expenses.map((expense) =>
            expensesApi.update(this.companyId, expense.id, {
              vehicle_id: this.newVehicleId,
            })
          )
        );

        const updatedExpenses = responses.map((r) => r.data.result);

        notificationStore.showSuccess(
          `Транспорт изменён у ${this.expenses.length} расходов`
        );

        this.$emit("changed", updatedExpenses);
      } catch (error) {
        console.error("Ошибка при массовой смене транспорта:", error);
        notificationStore.showError("Не удалось изменить транспорт");
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>

<style scoped>
.modal-form {
  display: flex;
  flex-direction: column;
}

.info-text {
  margin-bottom: 20px;
  font-size: 14px;
  color: #555;
  line-height: 1.5;
}

@media screen and (max-width: 767px) {
  .form-btn {
    flex: 1;
  }
}
</style>
